import axios from 'axios';

export const authApiAgent = axios.create({
  baseURL: import.meta.env.VITE_AUTH_API_URI,
});

export const wolfApiAgent = axios.create({
  baseURL: import.meta.env.VITE_WOLF_API_URI,
});

export const courierApiAgent = axios.create({
  baseURL: import.meta.env.VITE_COURIER_API_URI,
});

export const deliveryOsGatewayApiAgent = axios.create({
  baseURL: import.meta.env.VITE_DELIVERY_OS_GATEWAY_URI,
});
